import React from 'react';
import BRLogoAndName from './assets/betaReaderLogoAndName.svg?react';

const BetaReaderLogoAndName = () => (
  <BRLogoAndName role='img' aria-label='BetaReader' />
);

export default BetaReaderLogoAndName;
